"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@athena-portal/core");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var keycloak_1 = require("@athena-portal/keycloak");
var KeycloakApplicationGuard = /** @class */ (function (_super) {
    __extends(KeycloakApplicationGuard, _super);
    function KeycloakApplicationGuard(config) {
        var _this = _super.call(this) || this;
        _this.inProgress = false;
        _this.config = config;
        var keycloakInstanceConfig = {
            url: _this.config.url,
            realm: _this.config.realm,
            clientId: _this.config.clientId
        };
        _this.keycloak = new keycloak_1.default(keycloakInstanceConfig);
        _this.keycloak.onAuthError = function (errorData) { return _this.handleError(errorData); };
        _this.keycloak.onAuthRefreshError = function () { return _this.handleError(new Error('Authentication Refresh Error')); };
        _this.keycloak.onTokenExpired = function () { return _this.redirectToFeedback(); };
        return _this;
    }
    KeycloakApplicationGuard.prototype.doGuard = function (redirectUri, action) {
        var _this = this;
        this.inProgress = true;
        return this
            .loadClient()
            .pipe((0, operators_1.mergeMap)(function () {
            if (!_this.keycloak.authenticated) {
                return _this.keycloakPromiseToObservable(_this.keycloak.login({
                    redirectUri: redirectUri || _this.config.redirectUri,
                    action: action
                }));
            }
            return (0, rxjs_1.of)(true);
        }))
            .pipe((0, operators_1.mergeMap)(function () {
            return _this.keycloakPromiseToObservable(_this.keycloak.loadUserProfile());
        }))
            .pipe((0, operators_1.map)(function () {
            _this.emit(core_1.ApplicationGuardEvent.Login, _this.getUser());
            _this.inProgress = false;
            return true;
        }))
            .pipe((0, operators_1.catchError)(function (error) {
            _this.inProgress = false;
            error = error || new Error("Unknown Keycloak error happened");
            _this.logger.log("Keycloak error happened while executing doGuard(). Error: [".concat(core_1.JsonUtils.errorToString(error), "]"));
            throw error;
        }));
    };
    KeycloakApplicationGuard.prototype.modifyHttpRequest = function (request) {
        return this
            .fetchToken()
            .pipe((0, operators_1.map)(function (token) {
            request.headers = request.headers || {};
            request.headers["Authorization"] = "Bearer ".concat(token);
            return request;
        }));
    };
    KeycloakApplicationGuard.prototype.isAuthenticated = function () {
        return (this.keycloak && this.keycloak.authenticated && !!this.keycloak.profile) || false;
    };
    KeycloakApplicationGuard.prototype.logout = function (options) {
        var _this = this;
        // Workaround due to react router event interception issue
        this.emit(core_1.ApplicationGuardEvent.Logout);
        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var loginUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadClient().toPromise()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.keycloak.createLoginUrl(options)];
                    case 2:
                        loginUrl = _a.sent();
                        window.location.href = this.keycloak.createLogoutUrl({
                            redirectUri: loginUrl
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    KeycloakApplicationGuard.prototype.fetchToken = function () {
        var _this = this;
        return (0, rxjs_1.from)(new Promise(function (resolve) {
            _this.waitForLogin(function () {
                _this.keycloak.updateToken(1800).then(function () {
                    if (_this.keycloak.token) {
                        resolve(_this.keycloak.token);
                    }
                    else {
                        _this.handleError(new Error('Token is missing'));
                    }
                }).catch(function (error) {
                    _this.handleError(error ? error : new Error("Error happened while fetching Token"));
                });
            });
        }));
    };
    KeycloakApplicationGuard.prototype.getUser = function () {
        var _a;
        if (this.isAuthenticated()) {
            var user_1 = {
                name: this.keycloak.profile.username || "",
                email: this.keycloak.profile.email || "",
                firstName: this.keycloak.profile.firstName || "",
                lastName: this.keycloak.profile.lastName || "",
                emailVerified: this.keycloak.profile.emailVerified || "",
            };
            if (this.keycloak.tokenParsed &&
                this.keycloak.tokenParsed.realm_access &&
                this.keycloak.tokenParsed.realm_access.roles) {
                user_1.roles = this.keycloak.tokenParsed.realm_access.roles;
                user_1.id = this.keycloak.tokenParsed.sub;
            }
            if (((_a = this.keycloak.profile) === null || _a === void 0 ? void 0 : _a.attributes) && this.config.attributeMapping) {
                var attributes_1 = this.mapProfileAttributes(this.keycloak.profile.attributes);
                this.config.attributeMapping.forEach(function (mapping) {
                    mapping(attributes_1, user_1);
                });
            }
            return user_1;
        }
        return null;
    };
    KeycloakApplicationGuard.prototype.loginInProgress = function () {
        return this.inProgress;
    };
    KeycloakApplicationGuard.prototype.getLoginUrl = function (redirectUri) {
        var _this = this;
        var getLoginUrlAsync = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadClient().toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.keycloak.createLoginUrl({
                                redirectUri: redirectUri
                            })];
                }
            });
        }); };
        return (0, rxjs_1.from)(getLoginUrlAsync());
    };
    KeycloakApplicationGuard.prototype.getRegisterUrl = function (redirectUri) {
        var _this = this;
        var createRegisterUrlAsync = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadClient().toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.keycloak.createRegisterUrl({
                                redirectUri: redirectUri
                            })];
                }
            });
        }); };
        return (0, rxjs_1.from)(createRegisterUrlAsync());
    };
    KeycloakApplicationGuard.prototype.getChangePasswordUrl = function () {
        return this.config.url + "/realms/" + this.config.realm + "/account/password";
    };
    KeycloakApplicationGuard.prototype.loadClient = function () {
        if (!this.keycloak.clientId) {
            return this.keycloakPromiseToObservable(this.keycloak.init({
                checkLoginIframe: true
            }));
        }
        return (0, rxjs_1.of)(this.keycloak);
    };
    KeycloakApplicationGuard.prototype.waitForLogin = function (callback) {
        var _this = this;
        var loginSleepInterval = setInterval(function () {
            if (_this.inProgress) {
                console.log("sleep");
            }
            else if (!_this.isAuthenticated()) {
                _this.doGuard();
            }
            else {
                clearInterval(loginSleepInterval);
                callback();
            }
        }, 100);
    };
    KeycloakApplicationGuard.prototype.keycloakPromiseToObservable = function (promise) {
        return (0, rxjs_1.from)(promise);
    };
    KeycloakApplicationGuard.prototype.handleError = function (error) {
        throw error;
    };
    KeycloakApplicationGuard.prototype.redirectToFeedback = function () {
        var _this = this;
        // Create return URL from current location
        var redirectUrl = "".concat(window.location.protocol, "//").concat(window.location.host, "/keycloakFeedback");
        // Workaround due to react router event interception issue. Copied from logout method.
        this.emit(core_1.ApplicationGuardEvent.Logout);
        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadClient().toPromise()];
                    case 1:
                        _a.sent();
                        window.location.href = this.keycloak.createLogoutUrl({
                            redirectUri: redirectUrl
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    KeycloakApplicationGuard.prototype.mapProfileAttributes = function (attributes) {
        var retVal = {};
        for (var _i = 0, _a = Object.keys(attributes); _i < _a.length; _i++) {
            var key = _a[_i];
            var value = attributes[key];
            var valueAsArray = Array.isArray(value) ? value : [value];
            retVal[key] = valueAsArray;
        }
        return retVal;
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.LoggerService),
        __metadata("design:type", Object)
    ], KeycloakApplicationGuard.prototype, "logger", void 0);
    KeycloakApplicationGuard = __decorate([
        (0, core_1.injectable)(),
        __metadata("design:paramtypes", [Object])
    ], KeycloakApplicationGuard);
    return KeycloakApplicationGuard;
}(core_1.EventEmitter));
exports.default = KeycloakApplicationGuard;
//# sourceMappingURL=KeycloakApplicationGuard.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-keycloak/dist/services/KeycloakApplicationGuard.js
// module id = 2417
// module chunks = 0